import React from "react";

const MasterServicesPageIcon = ({ color = "currentColor", ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill={color}
      fillRule="evenodd"
      d="M18.183 4.581H16.22A2.963 2.963 0 0 0 13.286 2h-2.582A2.962 2.962 0 0 0 7.77 4.58l-1.953.001A3.816 3.816 0 0 0 2 8.388v3.467c0 .252.126.487.337.626 2.059 1.359 4.496 2.264 7.047 2.619a.743.743 0 0 0 .827-.545 1.827 1.827 0 0 1 1.779-1.356c.832 0 1.554.557 1.756 1.352a.75.75 0 0 0 .83.559c2.568-.355 5.016-1.265 7.078-2.629a.752.752 0 0 0 .336-.626V8.388a3.812 3.812 0 0 0-3.807-3.807Zm2.307 6.864c-1.643 1.021-3.537 1.736-5.531 2.087a3.307 3.307 0 0 0-2.969-1.833 3.355 3.355 0 0 0-2.979 1.824c-1.982-.349-3.87-1.06-5.511-2.078V8.388a2.315 2.315 0 0 1 2.318-2.307l2.678-.002a.75.75 0 0 0 .75-.751l-.001-.37A1.46 1.46 0 0 1 10.704 3.5h2.582c.673 0 1.242.459 1.409 1.081h-2.7a.75.75 0 0 0 0 1.5h6.188a2.31 2.31 0 0 1 2.307 2.307v3.057Zm-7.745 3.938v1.294a.75.75 0 0 1-1.5 0v-1.294a.75.75 0 0 1 1.5 0Zm8.47-.658a.741.741 0 0 0-.736.69s-.154 1.75-.186 2.301c-.037.611-.285 1.276-.632 1.693-.489.59-1.031.821-1.933.823l-6.197.002a.75.75 0 1 0-.001 1.5c2.328 0 5.642 0 6.201-.002 1.334-.003 2.315-.437 3.085-1.365.553-.666.917-1.623.974-2.56a161.24 161.24 0 0 1 .173-2.334.748.748 0 0 0-.748-.748ZM6.262 20.232l1.135.001c.414 0 .753.336.753.75s-.34.75-.755.75H6.26c-1.335-.004-2.316-.438-3.086-1.367-.552-.665-.917-1.622-.973-2.56-.023-.38-.099-1.358-.142-1.92l-.032-.413a.742.742 0 0 1 1.484-.057s.154 1.75.187 2.3c.037.611.284 1.276.631 1.692.49.592 1.032.822 1.933.824Z"
      clipRule="evenodd"
    />
  </svg>
);

export default MasterServicesPageIcon;
